module.exports = __webpack_public_path__ + "static/media/Ann_Sara_John.4f8f75e1.jpg";